const competitorComparisonPageSlugs = [
  "switch-from-vagaro-now",
  "switch-from-fresha",
  "switch-from-phorest",
  "switch-from-boulevard",
  "switch-from-milano",
  "switch-from-zenoti",
  "switch-from-meevo",
  "switch-from-rosy",
  "switch-from-booker",
  "switch-from-square",
  "mangomint-med-spa-software-aesthetic-record",
  "mangomint-med-spa-software-aestheticspro",
];

export { competitorComparisonPageSlugs };
